import PropTypes from 'prop-types'
import React from 'react'
import BarGraph from '../BarGraph'



const Intro = ({ article, articleTimeout, close, redirectClick }) => {

  return (
    <article
      id="skills"
      className={`${article === 'skills' ? 'active' : ''} ${articleTimeout ? 'timeout' : ''}`}
      style={{ display: 'none' }}
    >
      <h2 className="major">Skills</h2>

      <h3 className="minor">Language</h3>
      <div className="chart box">
        <BarGraph visible={{ bLogo: 6, bName: 20 }} level={63} article={article} text="html5" />
        <BarGraph visible={{ bLogo: 6, bName: 18 }} level={51} article={article} text="css3" />
        <BarGraph visible={{ bLogo: 6, bName: 15 }} level={35} article={article} text="js" />
        <BarGraph visible={{ bLogo: 6, bName: 20 }} level={50} article={article} text="php" />
      </div>

      <h3 className="minor">Framework</h3>
      <div className="chart box">
        <BarGraph visible={{ bLogo: 6, bName: 17 }} level={20} article={article} text="react" />
        <BarGraph visible={{ bLogo: 6, bName: 20 }} level={23} article={article} text="sass" />
        <BarGraph visible={{ bLogo: 6, bName: 25 }} level={28} article={article} text="bootstrap" />
        <BarGraph visible={{ bLogo: 6, bName: 25 }} level={55} article={article} text="laravel" />
      </div>

      <div className="pagination">
        <div className="pagination-left">
          <button onClick={() => { redirectClick('about'); }}><span className="icon fas fa-arrow-left"></span> About</button>
        </div>
        <div className="pagination-right">
          <button onClick={() => { redirectClick('project'); }}>
            Projects <span className="icon fas fa-arrow-right"></span>
          </button>
        </div>
      </div>

      {close}
    </article>
  );
}

Intro.propTypes = {
  article: PropTypes.string,
  articleTimeout: PropTypes.bool,
  close: PropTypes.object,
  redirectClick: PropTypes.func
}

export default Intro
